import { EChartOption } from "echarts";
import EchartsWrapper from "PFCore/helpers/echarts_wrapper";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import LinePreview from "../../previews/line_preview";
import css from "./platform_usage_signins_over_time.module.scss";

type PlatformUsageSigninsOverTimeProps = {
  data: {
    x: number;
    y: string;
  }[];
};

const PlatformUsageSigninsOverTime = ({ data }: PlatformUsageSigninsOverTimeProps): JSX.Element => {
  const { t } = useTranslation("insights");
  const { formatDate } = useDateFormatter();

  const options = useMemo<EChartOption>(
    () => ({
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        },
        formatter: (params) => `${t("signInsOn")} ${params[0].name}: <b>${params[0].value}</b>`
      },
      toolbox: {
        show: true,
        right: 20,
        feature: {
          saveAsImage: {
            title: t("saveImage"),
            backgroundColor: "transparent"
          }
        }
      },
      xAxis: {
        type: "category",
        data: data.map((point) => formatDate(point.x))
      },
      yAxis: {
        type: "value"
      },
      series: [
        {
          data: data.map((point) => point.y),
          type: "line"
        }
      ]
    }),
    [data, t, formatDate]
  );

  return (
    <div className={css.platformUsageSigninsOverTime}>
      {data.length > 0 ? (
        <>
          <h2>{t("signsInOverTime")}</h2>
          <EchartsWrapper options={options} height={500} />
        </>
      ) : (
        <LinePreview animated content={t("noData")} />
      )}
    </div>
  );
};

export default PlatformUsageSigninsOverTime;
